<mat-toolbar class="navbar" color="primary">
    <div>
        <mat-icon svgIcon="logo-white" class="logo-icon"></mat-icon>
        <span class="navbar-brand">CAREKARTE CareMoni CCJ Console</span>
        <span class="navbar-spacer"></span>
    </div>
    <div class="right-menu d-flex">
        <div>
            <button mat-button id="header-menu-button" class="size-16" (mouseenter)="openMenu(menuTrigger2)" (click)="navigateToPass()"
                [matMenuTriggerFor]="belowMenu" (mouseleave)="buttonLeave(menuTrigger2)" #menuTrigger2="matMenuTrigger">
                {{ fullName }}
            </button>
            <mat-menu #belowMenu="matMenu" yPosition="below" class="mat-menu-container p-y" [hasBackdrop]="false">
                <div (mouseenter)="enterSubMenu()" (mouseleave)="onMenuClosed(menuTrigger2)">
                    <!-- <button mat-menu-item class="text-center sub-menu border-bottom permission" disabled>
                        {{ roleName | translate }}
                    </button> -->
                    <button mat-menu-item class="text-center sub-menu profile" (click)="navigateToPass()">
                        {{ 'RIGHT_MENU.ACCOUNT_INFORMATION' | translate }}
                    </button>
                </div>
            </mat-menu>
        </div>
        <div>
            <span class="size-16">|</span>
            <span>
                <button mat-button class="size-16 logout" (click)="onLogout()">{{ 'RIGHT_MENU.LOGOUT' | translate
                    }}</button>
            </span>
        </div>
    </div>
</mat-toolbar>